import React, { memo, useState } from "react";
import { Platform, Text, TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, LoanRenewalScenario, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import ThemeProvider from "@voltmoney/theme";
import { Icon } from "../icon/Icon";
import { Space } from "../space/Space";
import { Typography } from "../typography/Typography";
import { Button } from "../button/Button";
import { isMobileViewApp } from "../stack/utils";
import { addCommasToNumber } from "../pages/utils";
import { LENDER_ID } from "../pages/constants";
const LoanRenewalExpiredDashboardCard = ({ creditLimitAmount, outStandingAmount = 0, loanExpiryDay, renewNowAction, repayAction, scenario = LoanRenewalScenario.FIRST_7_DAYS, dueDay, showCta = true, reOpenLoanAccountAction, customerSupportAction, isRepaymentInProgress = false, showInfoSection = true, triggerAction, lenderId, isLoanExpired, refundAction, isPendingLoanRenewal, clearDuesAction, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [btnLoading, setBtnLoading] = useState(false);
    const isFromMobileViewApp = isMobileViewApp();
    const _isFontMobile = () => {
        if (Platform.OS !== "web") {
            return true;
        }
        else if (isFromMobileViewApp) {
            return true;
        }
        else {
            return false;
        }
    };
    const isFontMobile = _isFontMobile();
    const CtaAction = () => {
        switch (scenario) {
            case LoanRenewalScenario.OUTSTANDING_EXPIRED:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Button, { label: 'Close loan and get refund', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: async () => {
                            setBtnLoading(true);
                            refundAction && await triggerAction(refundAction);
                            setBtnLoading(false);
                        } })));
                break;
            case LoanRenewalScenario.FIRST_7_DAYS:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Button, { label: outStandingAmount > 0
                            ? (lenderId?.toLowerCase() === LENDER_ID.TATA ? 'Clear dues' : 'Proceed to repay')
                            : 'Renew loan', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: async () => {
                            setBtnLoading(true);
                            if (outStandingAmount > 0) {
                                repayAction &&
                                    await triggerAction(repayAction);
                            }
                            else {
                                renewNowAction &&
                                    await triggerAction(renewNowAction);
                            }
                            setBtnLoading(false);
                        } })));
                break;
            case LoanRenewalScenario.FROM_7_TO_30_DAYS:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Button, { label: outStandingAmount > 0
                            ? 'Proceed to repay'
                            : 'Renew loan', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: async () => {
                            setBtnLoading(true);
                            if (outStandingAmount > 0) {
                                repayAction &&
                                    await triggerAction(repayAction);
                            }
                            else {
                                renewNowAction &&
                                    await triggerAction(renewNowAction);
                            }
                            setBtnLoading(false);
                        } })));
                break;
            case LoanRenewalScenario.AFTER_30_DAYS:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Button, { label: 'Reopen loan account', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: async () => {
                            setBtnLoading(true);
                            reOpenLoanAccountAction &&
                                await triggerAction(reOpenLoanAccountAction);
                            setBtnLoading(false);
                        } })));
                break;
            default:
                return (React.createElement(React.Fragment, null));
        }
    };
    const InfoCard = () => {
        switch (scenario) {
            case LoanRenewalScenario.LOAN_EXPIRED_WITHOUT_OUTSTANDING:
                return (isRepaymentInProgress === false || lenderId?.toLowerCase() === LENDER_ID.TATA) ? (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(TouchableOpacity, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            borderRadius: 8,
                            padding: 8,
                            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
                        }, onPress: () => {
                            customerSupportAction &&
                                triggerAction(customerSupportAction);
                        } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XL }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(View, { style: {
                                flex: 1
                            } },
                            React.createElement(Text, null,
                                React.createElement(Typography, { label: `Loan closure request will be raised in 1-3 business days. For any queries`, typeDLS: TypographyTypeDLS.B2M }),
                                React.createElement(Typography, { label: ` Contact\u00A0us`, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })))))) : (React.createElement(React.Fragment, null));
                break;
            case LoanRenewalScenario.OUTSTANDING_EXPIRED:
                return (isRepaymentInProgress === false || lenderId?.toLowerCase() === LENDER_ID.TATA) ? (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            borderRadius: 8,
                            padding: 8,
                            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1]
                        } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XL }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(View, { style: {
                                flex: 1
                            } },
                            React.createElement(Typography, { label: `Raise refund request and close your loan.`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Grey_Charcoal }))))) : (React.createElement(React.Fragment, null));
                break;
            case LoanRenewalScenario.FIRST_7_DAYS:
                return (isRepaymentInProgress === false || lenderId?.toLowerCase() === LENDER_ID.TATA) ? (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            borderRadius: 8,
                            padding: 8,
                            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1]
                        } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XL }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(View, { style: {
                                flex: 1
                            } },
                            React.createElement(Typography, { label: `Clear dues by ${dueDay ? dueDay : '7 Feb, 2024'} to avoid portfolio sell-off.`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Grey_Charcoal }))))) : (React.createElement(React.Fragment, null));
                break;
            case LoanRenewalScenario.FROM_7_TO_30_DAYS:
                return isRepaymentInProgress === false ? (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Typography, { label: `Repayment was due on ${dueDay ? dueDay : '7 Feb, 2024'}`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(TouchableOpacity, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            borderRadius: 8,
                            padding: 8,
                            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
                        }, onPress: async () => {
                            if (lenderId.toLowerCase() === LENDER_ID.TATA) {
                                await triggerAction(clearDuesAction);
                            }
                            else {
                                customerSupportAction &&
                                    await triggerAction(customerSupportAction);
                            }
                        } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XL }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(View, { style: {
                                flex: 1
                            } },
                            React.createElement(Text, null,
                                React.createElement(Typography, { label: lenderId.toLowerCase() === LENDER_ID.TATA ? 'Portfolio sell-off may have been initiated. Still want to repay? ' : `Portfolio sell-off initiated. For help `, typeDLS: TypographyTypeDLS.B2M }),
                                React.createElement(Typography, { label: lenderId.toLowerCase() === LENDER_ID.TATA ? `Clear\u00A0dues` : `Contact\u00A0support`, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })))),
                    lenderId.toLowerCase() === LENDER_ID.TATA && React.createElement(View, { style: { marginTop: 12 } },
                        React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: 'Contact support', width: ButtonWidthTypeToken.FULL, onPress: async () => {
                                customerSupportAction &&
                                    await triggerAction(customerSupportAction);
                            } })))) : (React.createElement(React.Fragment, null));
                break;
            case LoanRenewalScenario.AFTER_30_DAYS:
                return (React.createElement(React.Fragment, null));
                break;
            default:
                return (React.createElement(React.Fragment, null));
                break;
        }
    };
    const calCardTitle = () => {
        let title = '';
        if (isLoanExpired && lenderId.toLowerCase() === LENDER_ID.TATA && outStandingAmount < 0) {
            title = 'Outstanding amount';
        }
        else if (outStandingAmount > 0) {
            title = 'Overdue amount';
        }
        else
            title = 'Credit limit';
        return title;
    };
    const calRenewalAmount = () => {
        let amount = 0;
        if (isLoanExpired && lenderId.toLowerCase() === LENDER_ID.TATA && outStandingAmount < 0) {
            amount = outStandingAmount;
        }
        else if (outStandingAmount > 0) {
            amount = outStandingAmount;
        }
        else
            amount = creditLimitAmount;
        return amount;
    };
    const LoanRenewalCard = () => {
        return (React.createElement(View, { style: {
                borderRadius: 12,
                borderWidth: 1,
                borderColor: colorMapping[ColorTokens.Grey_Chalk],
                padding: 16,
                backgroundColor: colorMapping[ColorTokens.White]
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.XL }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: `Loan expired on ${loanExpiryDay ? loanExpiryDay : '31 Jan, 2023'}`, typeDLS: TypographyTypeDLS.H4S })),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(Typography, { label: calCardTitle(), typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(Typography, { label: `₹`, fontWeight: '700', color: outStandingAmount > 0 ? ColorTokens.System_Error : ColorTokens.Grey_Night, fontSize: isFontMobile
                        ? FontSizeTokens.XXXXL
                        : FontSizeTokens.XXL, lineHeight: Platform.OS === "android"
                        ? 40
                        : 32 }),
                React.createElement(Typography, { label: `${addCommasToNumber(calRenewalAmount())}`, typeDLS: TypographyTypeDLS.H1B, color: outStandingAmount > 0 ? ColorTokens.System_Error : ColorTokens.Grey_Night })),
            showInfoSection &&
                InfoCard(),
            (isRepaymentInProgress === false || lenderId?.toLowerCase() === LENDER_ID.TATA) &&
                showCta &&
                (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    CtaAction()))));
    };
    const content = (isLoanExpired && isPendingLoanRenewal) ? null : React.createElement(LoanRenewalCard, null);
    return (React.createElement(View, { style: {
            width: '100%',
            paddingHorizontal: 16,
            paddingBottom: 16,
        } }, content));
};
export default memo(LoanRenewalExpiredDashboardCard);
export { LoanRenewalExpiredDashboardCard };
